export default {
  // 工作台
  workbench: {
    introduction: '可视化的组织工具，可以帮助您更快，更准确地管理和监督项目的开发',
    addmemo: '新增备忘录',
    overdue: '超时待办',
    today: '今日待办',
    tomorrow: '明日要做',
    later: '以后要做',
    allToDo: '全部待办',
    overduenote: '截止今日超期任务',
    todaynote: '截止今日需要完成任务',
    tomorrownote: '明日需要完成任务',
    laternote: '未来任务安排',
    taskError: '请输入任务名称！',
    addschedule: '新建日程',
    switchColleagues: '切换同事',
    soOn: '等',
    people: '人',
    individual: '个人',
    executor: '执行人',
    endtime: '设置截止时间',
    inputname: '请输入任务名称',
    leave: '请假单',
    overtime: '加班申请单',
    memonote1: '今天在客户现场，客户就产品的质量问题提出了自己的建议，在我们货运过程中...',
    memonote2: '销售反馈问题：1、在客户界面下，客户的优先级要通过颜色进行标识，下次联系...',
    memonote3: '数据分析统计是根据对比和阶段数据来呈现销售的业绩轨迹，如果在我们没有...',
    duty_name: '员工',
    member: '成员姓名',
    name: '名称',
    visibleMember: '可见成员',
    addMember: '可见成员',
    modifier: '修改人',
    edittime: '修改时间',
    status: '状态',
    operation: '操作',
    disableTip: '确定要禁用该门户吗？',
    enableTip: '确定要启用该门户吗？',
    deleteTip: '确定要删除该门户吗？',
    workset: '工作台设置',
    workName: '工作台名称',
    set: '设置',
    pagelayout: '页面布局',
    customcomponent: '自定义组件',
    advancedcomponent: '高级类组件',
    last: '上一步',
    next: '下一步',
    namerestriction: '门户名称限制12字内',
    workname_empty: '工作台名称不能为空',
    taskShow: '任务显示',
    showstyle: '显示样式',
    showT: '单独显示任务',
    showTS: '显示任务和日程',
    show: '显示',
    tasklist: '任务列表',
    view: '视图',
    submenu: '子菜单',
    custommodule: '自定义模块',
    submenuname: '子菜单名称',
    customapp: '自定义应用',
    customapp_empty: '自定义应用不能为空',
    custommodule_empty: '自定义模块不能为空',
    submenu_empty: '子菜单名称不能为空',
    name_empty: '名称不能为空',
    chart: '图表',
    project: '项目',
    allCustomer: '全部客户',
    szHighSeasPool: '深圳公海池',
    shHighSeasPool: '上海公海池',
    bjHighSeasPool: '北京公海池',
    gzHighSeasPool: '广州公海池',
    ym: 'yyyy年MM月',
    time: '时间',
    enclosure: '附件',
    remind: '提醒',
    noRemind: '不提醒',
    beforeStartTime: '起始时间前',
    participant: '参与人',
    startTime: '起止日期',
    addAttachment: '添加附件',
    viewScheduleAssistant: '查看日程排期小助手',
    startTime_empty: '开始时间不能为空',
    endTime_empty: '结束时间不能为空',
    time_error: '开始时间不能大于或等于结束时间',
    remindTime_empty: '提醒时间不能为空',
    fileSize: '每个附件大小不得超过20MB',
    businessprocess: '业务流程',
    datalist: '数据列表',
    total: '共',
    a: '项',
    beginnerboot: '新手引导',
    watchvideointroduction: '观看视频介绍',
    exploretheteamfaceapp: '探索应用',
    createformprocessdataanalysis: '创建表单/流程/数据报表',
    invitemembers: '邀请成员',
    guide1:
      '1/4 我们是一个企业数据管理一体化平台系统，简单好用易上手，系统预置的固定模块打开即用。',
    guide2: '2/4 我们拥有丰富的业务应用和行业应用，一键安装，立即实现您的管理诉求。',
    guide3: '3/4 想要自由创建您的专属系统？3分钟带你实现从0到1搭建贴合您企业需求的定制系统。',
    guide4: '4/4 想要实现深度定制？我们一对一专属定制顾问将竭诚为您服务~',
    guide5: '1/4  从0开始布局，拖拉拽搭建，自由定义每一个模块。',
    guide6: '2/4 创建的应用模块可根据企业不同的应用场景进行流程自定义设置，如报销、请假、申请等。',
    guide7:
      '3/4 企业流程由系统自动化运行，智能触发计划好的业务步骤，实现工作高效化、数据可视化、流程精细化管理。',
    guide8: '4/4 根据实际需要，可自由定义想查看的数据类型，数据范围，数据统计报表呈现样式等。',
    experienceitnow: '立即体验',
    datetimedisplay: '日期时间显示',
    headingtext: '标题文字',
    contenttextclickmoreadddata: '内容文字，点击更多添加数据',
    announcementtitle: '公告标题',
    announcementcontenttip: '公告内容，点击在右边增加数据来源',
    today3: '今',
    overdue2: '超期·',
    today2: '今日·',
    tomorrow2: '明日·',
    later2: '以后·',
    completed2: '已完成·',
    seemore: '查看更多…',
    selectviewrange: '选择查看范围',
    unfinished: '未完成',
    selectviewer: '选择查看人员',
    allitems: '全部项目',
    calendarview: '日历视图',
    teamstatus: '团队状态',
    unknowntime: '未知时间',
    contentdeleteTip: '这是一段内容这是一段内容确定删除吗？',
    addmembersmanually: '手动添加成员',
    individualtasks: '个人任务',
    draft: '草稿',

    schedulesharing: '日程共享',
    portalname: '门户名称',
    schedulesharingsettings: '日程共享设置',
    schedulesharingsettingsTip:
      '通过设置可以将某个成员、部门或角色的日程共享给其他人，其他人可通过日程进行查看。',
    serialnumber: '序号',
    shareer: '共享者',
    shareto: '共享给',
    newagendasharing: '新建日程共享',
    editportal: '编辑门户',
    createportal: '创建门户',
    portalicon: '门户图标',
    selecticon: '选择图标',
    portalnamecannotbeempty: '门户名称不能为空',
    visiblemembercannotbeempty: '可见成员不能为空',
    sharewaremustfill: '共享者必填',
    sharedtorequired: '共享给必填',
    editingportal: '正在编辑门户：',
    portalinterfaceconfiguration: '门户界面配置',
    selectbase: '选择底图',
    nobase: '无底图',
    basetype: '底图类型',
    color: '颜色',
    uploadimage: '上传图片',
    imagesisrecommende: '建议使用1920*1080或更大尺寸的图片限5M',
    addimage: '添加图片',
    backgroundimagedisplaymode: '背景图显示方式',
    selectcolor: '选择颜色',
    restoredefault: '恢复默认',
    selectouterbox: '选择外框',
    title: '标题',
    headingfont: '标题字体',
    titlebackground: '标题背景',
    background: '背景',
    backgroundsettings: '背景设置',
    frame: '外框',
    outsidebox: '栏目外框',
    layout: '布局',
    selectlayout: '选择布局',
    component: '组件',
    theme: '主题',
    transparenttheme: '透明主题',
    freelayout: '自由布局',
    onecolumnlayout: '一栏布局',
    twocolumnlayout: '二栏布局',
    threecolumnlayout: '三栏布局',
    otherlayouts: '其他布局',
    wheelplot: '轮播图',
    tabswitch: 'Tab切换',
    columnone: '栏目一',
    column2: '栏目二',
    quickaccess: '快捷入口',
    shortcutbutton: '快捷按钮',
    shortcutbuttonone: '快捷按钮一',
    shortcutbutton2: '快捷按钮二',
    graphic: '图文',
    announcements: '公告',
    statistics: '统计',
    projectmanagement: '项目管理',
    lanemap: '泳道图',
    embeddedurl: '嵌入URL',
    filesizemustnotexceed5mb: '文件大小不得超过5MB',
    image_empty: '【图片】内容不能为空',
    slidesnumber_empty: '【轮播图】数量不能为空',
    slidescontent_empty: '【轮播图】内容不能为空',
    video_empty: '【视频】内容不能为空',
    tabsnum_empty: '【Tab切换】数量不能为空',
    tabscontent_empty: '【Tab切换】操作内容不能为空',
    quickentrynum_empty: '【快捷入口】数量不能为空',
    quickentrycontent_empty: '【快捷入口】操作内容不能为空',
    imagetextitem_empty: '【图文】栏目名称不能为空',
    imagetextcontent_empty: '【图文】内容来源模块不能为空',
    imagetexttitle_empty: '【图文】标题不能为空',
    imagetextimage_empty: '【图文】图片不能为空',
    noticecontent_empty: '【公告】内容来源模块不能为空',
    noticetitle_empty: '【公告】标题不能为空',
    noticecontent2_empty: '【公告】内容不能为空',
    viewnum_empty: '【视图】数量不能为空',
    chartname_empty: '【统计】数据分析表单名称不能为空',
    chart_empty: '【统计】图表不能为空',
    url_empty: '【嵌入URL】url不能为空',
    sharepermissions: '共享权限',
    readonly: '只读',
    imagesettings: '图片设置',
    imagecontent: '图片内容',
    linkaddress: '链接地址',
    picturetext: '图片文字',
    imagedisplaymode: '图片显示方式',
    rotationsset: '轮播图设置',
    numberofrotationplots: '轮播图数量',
    addupto5images: '最多添加5张图片',
    videosettings: '视频设置',
    videodisplay: '视频显示',
    notitle: '无标题',
    withatitle: '有标题',
    addvideo: '添加视频',
    videoaddress: '视频地址',
    localupload: '本地上传',
    supporttencentyouku: '支持腾讯、优酷视频。',
    localvideo: '本地视频',
    videodisplaymode: '视频显示方式',
    tabtogglesettings: 'Tab切换设置',
    styleselection: '风格选择',
    tabcolumn: 'Tab栏目',
    tabcolumnone: 'Tab栏目一',
    tabcolumn2: 'Tab栏目二',
    tabcolumn3: 'Tab栏目三',
    tabswitchnumber: 'Tab切换数量',
    addupto10tabs: 'Tab数量最多添加10个',
    shortcutentrysettings: '快捷入口设置',
    shortcutstyle: '快捷操作样式',
    button: '按钮',
    entrance: '入口',
    singlebuttonwidth: '单个按钮宽度',
    equal: '等分',
    adaptivetext: '自适应文字',
    backgroundcolor: '背景颜色',
    displaystyle: '展示样式',
    defaultstyle: '默认样式',
    adddivider: '加分隔线',
    numberofrows: '单行数量',
    addoperation: '添加操作',
    graphicsettings: '图文设置',
    columnname: '栏目名称',
    displaytype: '展示类型',
    text: '文本',
    graphictypestructure: '图文类型结构',
    around: '左右',
    upanddown: '上下',
    texttype: '文本类型',
    titlecontent: '标题+内容',
    displaycolumncount: '显示列数',
    displayheight: '显示高度',
    graphicratio: '图文占比',
    textposition: '文字位置',
    totheleft: '居左',
    centered: '居中',
    totheright: '居右',
    graphiccontentsourcemodule: '图文内容来源模块',
    correspondingdisplayfield: '对应显示字段',
    announcementsettings: '公告设置',
    banner: '横幅',
    panel: '面板',
    runningupanddownthelantern: '上下跑马灯',
    runninghorselampleftandright: '左右跑马灯',
    showtitle: '展示标题',
    paneldisplay: '面板显示',
    singledata: '单条数据',
    multipledata: '多条数据',
    bulletindisplaynumber: '公告展示条数',
    viewsettings: '视图设置',
    textdisplaystructure: '文字显示结构',
    singlecolumn: '单列',
    doublecolumn: '双列',
    statisticssettings: '统计设置',
    dataanalysisformname: '数据分析表单名称',
    numericalappearanceadjustment: '数值外观调整',
    default: '默认',
    fontcolor: '字体颜色',
    embeddedurlsettings: '嵌入URL设置',
    enterurl: '输入URL',
    schedulesettings: '日程设置',
    columnnamelocation: '栏目名称位置',
    displaycontent: '展示内容',
    swimlanemapsettings: '泳道图设置',
    displaynumberofrows: '显示行数',
    selectdata: '选择数据',
    addbutton: '添加按钮',
    performoperations: '执行操作',
    operationcontent: '操作内容',
    buttonname: '按钮名称',
    icon: '图标',
    newdata: '新增数据',
    opensubmenu: '打开子菜单',
    openlink: '打开链接',
    repeatedsubmenu: '子菜单已重复',
    datasourcecannotbenull: '数据来源不能为空',
    columnnamecannotbeempty: '栏目名称不能为空',
    buttonnamecannotbeempty: '按钮名称不能为空',
    linkaddresscannotbeempty: '链接地址不能为空',
    operationcontentcannotbeempty: '操作内容不能为空',
    style1: '样式一',
    style2: '样式二',
    empty: '空',
    // 20201224
    newtype: '新增类型',
    createdIn: '创建于',
    // 20210715
    deptask: '部门任务',
    degreeemergency: '紧急程度',
    // 20220412
    lastmonth: '上个月',
    nextmonth: '下个月',
    basicapplication: '基础应用',
    customapplication: '定制应用',
    welcomeunlockTF: '欢迎一起来解锁！',
    step1: '第一步',
    step2: '第二步',
    step3: '第三步',
    step4: '第四步',
    firstmeetTF: '初识我们',
    whatcanTFdoforyou: '可为您做什么',
    learnabouttfapplication: '了解应用',
    iftfapplicationbuilt: '如果搭建应用',
    createfirstapplication: '创建第一个应用',
    practicefromfield: '从模板创建练练手',
    howfindmyapp: '如何找到我的应用',
    finishopeningpreviousstep: '完成上一步教程后才可开启此教程',
    closeafterreading: '请看完新手引导后再关闭',
    field: '123123123',
    // 2024-05-23
    backlogData: '待办数据',
    pendingTask: '待处理任务',
    processedTask: '已处理任务',
    toBeProcessed: '待处理',
    pendingApprovalProcess: '待处理审批流程',
    businesstobeprocessed: '待处理业务流程',
    attendanceTobeconfirmed: '待确认考勤',
    pendingPerformanceReview: '待处理绩效考核',
    pendingPayrollPpproval: '待处理薪酬审批',
    customapptobeprocessed: '待处理定制应用',
    owningModule: '所属模块',
    nodeArrivalTime: '节点到达时间',
    TaskStartEndTime: '任务起止时间',
    confirmationDeadline: '确认截止时间',
    assessmentName: '考核名称',
    assessor: '考核人',
    assessmentCycle: '考核周期',
    CurrentStage: '当前阶段',
    payName: '薪酬名称',
    searchTitle: '搜索标题',
    SearchTaskName: '搜索任务名称',
    SearchAttendanceName: '搜索考勤名称',
    SearchTestName: '搜索考核名称',
    SearchSalaryName: '搜索薪酬名称',
    allDay: '全天',
    change: '更改',
    customRepeat: '自定义重复',
    repeatTate: '重复频率',
    endRepeat: '结束重复',
    notRepeat: '不重复',
    everyDayRepeat: '每个工作日重复',
    limitedDegree: '限定次数',
    neverEnd: '永不截止',
    repeatTateNotEmpty: '重复频率不能为空',
    repeatTateError: '重复频率格式错误',
    deadlineNotEmpty: '截止时间不能为空',
    degreeEmpty: '限定次数不能为空',
    degreeError: '限定次数格式错误',
    deleteBacklog: '确定要删除该待办吗？',
    batchDelete: '批量删除',
    cutomAppTips:
      '仅用于对前端【定制应用】的待办数据删除处理，删除后负责人的待办事项将不会在显示，此操作不可恢复（其余类型待办数据同数据实时同步，从原始数据处理即可）。',
    schedule: '日程',
    effectiveTime: '生效时间',
    every: '每个',
    everyWorkingDay: '每个工作日',
    mondayToFriday: '星期一至星期五',
    terminationRepeat: '次后终止重复',
    pleaseInputPhoneNo: '请输入电话号码',
    noDataFound: '未搜索到数据',
    searching: '搜索中...'
  }
}
